import * as logger from 'loglevel';
import { vaccinatedMap } from '../travels';
import { encodeUrlQueryData } from '../../../helpers/utils';

const buildQuery = (filter, encodeUrlQuery = true) => {
  /*INFO: queryFields is an array of parameters that will be
          sent to the API, it can be a string and that will 
          look for its value in the prePopulation or an object
          to define an alias when it is sent to the API */
  const params = {};
  const { queryFields } = filter;
  if (Array.isArray(queryFields) && queryFields.length > 0) {
    queryFields.forEach((item) => {
      if (typeof item === 'object') {
        Object.keys(item).forEach((key) => {
          if (Array.isArray(filter[key])) {
            params[item[key]] = filter[key][0];
          } else {
            params[item[key]] = filter[key];
          }
        });
      } else {
        params[item] = filter[item];
      }
    });
    return encodeUrlQuery ? `&${encodeUrlQueryData(params)}` : params;
  } else {
    const MESSAGE = `INTEGRATION__FARES: **queryFields** not detected or are incorrect.`;
    logger.error(MESSAGE);
    return '';
  }
};

const buildQuerySmartvel = (filter) => {
  /*INFO: queryFields is an array of parameters that will be
          sent to the API, it can be a string and that will 
          look for its value in the prePopulation or an object
          to define an alias when it is sent to the API */

  const params = {};
  const { queryFields } = filter;
  if (Array.isArray(queryFields) && queryFields.length > 0) {
    queryFields.forEach((item) => {
      if (typeof item === 'object') {
        Object.keys(item).forEach((key) => {
          if (Array.isArray(filter[key])) {
            params[item[key]] = filter[key][0];
          } else {
            if (typeof filter[key] === 'object' && filter[key].value !== undefined) {
              params[item[key]] = filter[key].value;
            } else {
              if (
                filter[key] === vaccinatedMap.FULLY_VACCINATED ||
                filter[key] === vaccinatedMap.NOT_VACCINATED
              ) {
                params[item[key]] =
                  filter[key] === vaccinatedMap.FULLY_VACCINATED ? 'true' : 'false';
              } else {
                params[item[key]] = filter[key];
              }
            }
          }
        });
      } else {
        params[item] = filter[item];
      }
    });
    return `&${encodeUrlQueryData(params)}&plain_text=true`;
  } else {
    const MESSAGE = `INTEGRATION__FARES: **queryFields** not detected or are incorrect.`;
    logger.error(MESSAGE);
    return '';
  }
};

export { buildQuery, buildQuerySmartvel };
